module.exports = __webpack_public_path__ + "static/media/ai.83087812.jpg";